import React, {useState} from 'react';
import {Images} from "../../AssetReferences";
import {ImageLink} from "../../components/image_link";
import s from "./cybershore_cover_styles.module.css"
import {Images as CyberImages, Text as CyberText} from "./cybershore_data";

const path_to_meditations_text = "./toi/meditations"


export default function CybershoreCover({onStartGame, onOpenMeditationText}) {
    return (
        <div id={"cybershore cover"}>

            <div className={s.coverContainer}>

                <div className={s.cybershoreCover}>
                    <h1>Cybershore Meditations</h1>

                    {CyberText.About.map((content, index) => (<div key={index}>{content}</div>))}

                    <div className={s.cover_start_section}>
                        <p>
                            Click the button below to begin the interactive experience.
                        </p>


                        {/* translate below = .cover_start_btn width / 2. */}
                        <div style={{translate: 0}}>
                            <CybershoreStartButton onPress={onStartGame}/>
                        </div>
                    </div>

                    <br/>
                    <br/>

                    <div style={{textAlign: "center"}}>
                        <p>
                            You can also access the meditations through the links below.
                        </p>

                        <div style={{display: "flex", justifyContent: "space-evenly"}}>
                            <MeditationLink index={1} onPress={onOpenMeditationText}/>
                            <MeditationLink index={2} onPress={onOpenMeditationText}/>
                            <MeditationLink index={3} onPress={onOpenMeditationText}/>
                        </div>


                    </div>

                    <h2>Credits</h2>
                    <p>
                        Toi Guy in collaboration with Kiik Amor (Sound Design), Studio Misti (3D Design), and George
                        Micah
                        Kuhn (Unity Programming).
                    </p>
                </div>
            </div>
        </div>)
}

function CybershoreStartButton({onPress}) {

    function handleInteractionEvent(e) {
        if (e.type === "click") {
            onPress?.();
        } else if (e.type === "keyup") {
            if (e.key === "Enter" || e.key === " ") {
                onPress?.();
            }
        }
    }

    return (
        <img
            id={"cybershore start button"}
            src={Images.ToiSmall}
            className={s.cover_start_btn}
            onClick={handleInteractionEvent}
            onKeyUp={handleInteractionEvent}
            alt={"Button to start Cybershore Meditations"}
            title={"Click to start Cybershore Meditations"}
            tabIndex={0}
        />

    )
}

export function MeditationLink({index, onPress, size = "20em", tooltip}) {
    function handleInteractionEvent(e) {
        if (e.type === "click") {
            onPress?.(index);
        } else if (e.type === "keyup") {
            if (e.key === "Enter" || e.key === " ") {
                onPress?.(index);
            }
        }
    }

    function GetIcon(index) {
        switch (index) {
            case 1:
                return CyberImages.Meditation1Icon;
            case 2:
                return CyberImages.Meditation2Icon;
            case 3:
                return CyberImages.Meditation3Icon;
            default:
                console.error(`MeditationLink.GetIcon, icon index :${index} not recognised.`);
        }
        return null;
    }

    return (
        <div id={"meditation_" + index}>
            <img
                id={"meditation icon " + index}
                alt={tooltip ?? "Link to meditation " + index}
                title={tooltip ?? "Click to go to meditation " + index}
                src={GetIcon(index)}
                onClick={handleInteractionEvent}
                onKeyUp={handleInteractionEvent}
                tabIndex={0}
                className={s.meditations_link}
                style={{
                    cursor: "pointer",
                    width: size,
                }}
            />

        </div>
    )
}